import { Box } from "@mui/material";
import React from "react";
import MainHeader from "../../shared/MainHeader";

import ClosedCaseTable from "../../components/ClosedCasetable";

const OpenCases = () => {
  return (
    <Box>
      <MainHeader headingText={"Closed Cases"} />
      <ClosedCaseTable />
    </Box>
  );
};

export default OpenCases;
